import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { FundraisingTransaction } from 'src/models/FundraisingModel';

export const getFundraisingTransactionData =
  (organisation: string, id: string) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.fundraisingTransaction}/${id}`,
    organisation,
  });

export const putFundraisingTransactionData =
  (organisation: string, fundraisingTransaction: FundraisingTransaction) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.fundraisingTransaction}/${fundraisingTransaction.id}`,
    organisation,
    data: fundraisingTransaction,
  });
